export enum AdobeEvents {
  FORM_INTERACTION = 'formInteraction',
  LINK_INTERACTION = 'linkInteraction',
  PAGE_VIEW = 'pageView',
}

export const FURTHER_ADOBE_SETUP_WAIT_TIME = 500;
